// @flow
export const getStoreTopUpGameSku = () => (window.STORE_TOPUP_GAME_SKU);
export const validateUserID = (userID: string) => window.validationPartnerMethod(userID);
